/* Alhana theme — shared behaviour (vanilla, no dependencies).
   - [data-toggle-target]: buttons that open/close a panel (menus, drawers, filters) with aria-expanded.
   - [data-qty]: −/+ around a number input.
   - Escape closes the open panel and returns focus to its toggle.
   - Clicks on a WhatsApp chat link (wa.me/<number>) or a tel: link publish one custom event, «whatsapp_click» or
     «phone_click», with the page type, handle, SKU and where the link sits, for the Customer events pixel
     (Settings → Customer events). Share links (wa.me/?text=…) are not counted. window.alhanaTrack(name, placement)
     publishes the same event from a script (the home «ساعدني أختار» form opens WhatsApp without a link click).
   - [data-ann-rotate]: the announcement bar's messages take turns on phones (1.0.12, replaces a CSS animation).
   - time[data-prices-anchor] (snippets/prices-updated.liquid): «الأسعار محدّثة بتاريخ …» is computed when Liquid renders
     the page and Shopify may serve a cached render, so the same rule (anchor + whole weeks since the anchor, shop
     calendar Africa/Cairo) runs again here on the SERVER's date (Date header of HEAD /cart.js, asked only when the
     device clock says a step is due; a wrong phone clock alone never changes the date); the date only moves forward,
     at most 8 weeks past the rendered one.
   - a click on a link to a place on the same page, or a hash change without a click, adds html.cv-off (1.0.13), so
     the content-visibility skipping of off-screen home sections can't make the jump land in the wrong place. */
(function () {
  "use strict";

  function setOpen(button, panel, open) {
    button.setAttribute("aria-expanded", String(open));
    panel.classList.toggle("is-open", open);
    if (panel.hasAttribute("hidden") || !open) panel.hidden = !open;
    document.documentElement.classList.toggle("has-panel-open", open && panel.dataset.lockScroll === "true");
    if (open) {
      var focusable = panel.querySelector("input, button, a, select, textarea, [tabindex]");
      if (focusable) setTimeout(function () { focusable.focus(); }, 30);
    }
  }

  document.addEventListener("click", function (e) {
    var button = e.target.closest("[data-toggle-target]");
    if (!button) return;
    var panel = document.getElementById(button.getAttribute("data-toggle-target"));
    if (!panel) return;
    e.preventDefault();
    var open = button.getAttribute("aria-expanded") !== "true";
    // a close button inside the panel points at the same target
    document.querySelectorAll('[data-toggle-target="' + panel.id + '"]').forEach(function (b) {
      b.setAttribute("aria-expanded", String(open));
    });
    setOpen(button, panel, open);
    if (!open) {
      var opener = document.querySelector('[data-toggle-target="' + panel.id + '"]:not([data-toggle-close])');
      if (opener) opener.focus();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var openPanel = document.querySelector(".is-open[id]");
    if (!openPanel) return;
    var opener = document.querySelector('[data-toggle-target="' + openPanel.id + '"]:not([data-toggle-close])');
    if (opener) {
      setOpen(opener, openPanel, false);
      document.querySelectorAll('[data-toggle-target="' + openPanel.id + '"]').forEach(function (b) {
        b.setAttribute("aria-expanded", "false");
      });
      opener.focus();
    }
  });

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-qty] button");
    if (!btn) return;
    var input = btn.closest("[data-qty]").querySelector("input");
    if (!input) return;
    var step = btn.hasAttribute("data-qty-plus") ? 1 : -1;
    var min = parseInt(input.min || "0", 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.value = next;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  function placementOf(link) {
    if (link.closest(".wa-float")) return "float";
    if (link.closest("header, .announcement")) return "header";
    if (link.closest("footer")) return "footer";
    if (link.closest("product-info, .pbuy")) return "product";
    var section = link.closest("[id^='shopify-section-']");
    return section ? section.id.replace("shopify-section-", "") : "page";
  }

  function track(name, placement) {
    var body = document.body;
    var skuEl = document.querySelector("[data-sku]:not(body)");
    var data = {
      page_type: body.getAttribute("data-page-type") || "",
      handle: body.getAttribute("data-handle") || "",
      sku: (skuEl && skuEl.textContent.trim()) || body.getAttribute("data-sku") || "",
      placement: placement || "page",
      path: window.location.pathname
    };
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (err) {
      /* measurement must never block the link */
    }
  }
  window.alhanaTrack = track;

  /* Announcement bar on phones ([data-ann-rotate] = seconds per message): moves «is-active» to the next message.
     Runs only below 750px, never with reduced motion, and pauses on hover / focus and while the tab is hidden. */
  function rotateAnnouncements() {
    var bars = document.querySelectorAll("[data-ann-rotate]:not([data-ann-ready])");
    if (!bars.length || !window.matchMedia) return;
    var narrow = window.matchMedia("(max-width: 749px)");
    var still = window.matchMedia("(prefers-reduced-motion: reduce)");
    Array.prototype.forEach.call(bars, function (bar) {
      var items = bar.querySelectorAll(".announcement__item");
      bar.setAttribute("data-ann-ready", "");
      if (items.length < 2) return;
      var step = Math.max(3, parseInt(bar.getAttribute("data-ann-rotate"), 10) || 5) * 1000;
      var index = 0;
      var timer = null;
      var held = false;
      function show(i) {
        items[index].classList.remove("is-active");
        index = i % items.length;
        items[index].classList.add("is-active");
      }
      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }
      function sync() {
        stop();
        if (!bar.isConnected) return;
        if (!narrow.matches || still.matches) {
          if (index !== 0) show(0);
          return;
        }
        if (held || document.hidden) return;
        timer = setInterval(function () { show(index + 1); }, step);
      }
      bar.addEventListener("mouseenter", function () { held = true; sync(); });
      bar.addEventListener("mouseleave", function () { held = false; sync(); });
      bar.addEventListener("focusin", function () { held = true; sync(); });
      bar.addEventListener("focusout", function () { held = false; sync(); });
      document.addEventListener("visibilitychange", sync);
      if (narrow.addEventListener) {
        narrow.addEventListener("change", sync);
        still.addEventListener("change", sync);
      }
      sync();
    });
  }
  rotateAnnouncements();
  document.addEventListener("shopify:section:load", rotateAnnouncements);

  // «الأسعار محدّثة بتاريخ …»: re-step a cached render's date (see the header). Day numbers are UTC days of the calendar
  // dates, so the arithmetic has no time-zone or DST edge. Today is the server's (the Date header of an uncached
  // HEAD /cart.js) on the Cairo calendar: the device clock can be days or weeks off, so it only decides whether that
  // request is worth making (a step past the rendered date looks due); no step due → no request.
  function stepPricesDate() {
    var els = document.querySelectorAll("time[data-prices-anchor]");
    if (!els.length || !window.Intl || !Intl.DateTimeFormat.prototype.formatToParts || !window.fetch) return;
    var cairoDay = function (date) {
      var parts = {};
      try {
        new Intl.DateTimeFormat("en-US", { timeZone: "Africa/Cairo", year: "numeric", month: "numeric", day: "numeric" })
          .formatToParts(date)
          .forEach(function (p) { parts[p.type] = p.value; });
      } catch (err) {
        return NaN;
      }
      return Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)) / 864e5;
    };
    var dayOf = function (iso) {
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || "");
      return m ? Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])) / 864e5 : NaN;
    };
    // the day this element should show on `today`, or NaN when the rendered date stays
    var stepOf = function (el, today) {
      var anchor = dayOf(el.getAttribute("data-prices-anchor"));
      var rendered = dayOf(el.getAttribute("datetime"));
      var months = (el.getAttribute("data-months") || "").split(",");
      if (isNaN(today) || isNaN(anchor) || isNaN(rendered) || months.length !== 12 || today <= anchor) return NaN;
      var shown = anchor + Math.floor((today - anchor) / 7) * 7;
      return shown > rendered && shown <= rendered + 56 ? shown : NaN;
    };
    var due = Array.prototype.some.call(els, function (el) { return !isNaN(stepOf(el, cairoDay(new Date()))); });
    if (!due) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    fetch(root + "cart.js", { method: "HEAD", cache: "no-store", credentials: "same-origin" })
      .then(function (res) {
        var today = cairoDay(new Date(res.headers.get("Date") || ""));
        Array.prototype.forEach.call(els, function (el) {
          var shown = stepOf(el, today);
          if (isNaN(shown)) return;
          var months = el.getAttribute("data-months").split(",");
          var d = new Date(shown * 864e5);
          el.setAttribute("datetime", d.toISOString().slice(0, 10));
          el.textContent = d.getUTCDate() + " " + months[d.getUTCMonth()].trim() + " " + d.getUTCFullYear();
        });
      })
      .catch(function () {});
  }
  stepPricesDate();
  document.addEventListener("shopify:section:load", stepPricesDate);

  document.addEventListener(
    "click",
    function (e) {
      var link = e.target.closest ? e.target.closest("a[href]") : null;
      if (!link) return;
      var href = link.getAttribute("href") || "";
      var name = null;
      if (/^tel:/i.test(href)) name = "phone_click";
      else if (/^https?:\/\/(wa\.me|api\.whatsapp\.com)\/(send\?phone=)?\+?\d/i.test(href)) name = "whatsapp_click";
      if (!name) return;
      track(name, placementOf(link));
    },
    true
  );

  // 1.0.13: a link to a place on this page (e.g. «ساعدني أختار» → /#well-helper) first turns off the
  // content-visibility skipping of off-screen home sections (base.css: html.cv-off), so every block above the
  // target has its real height and the jump (smooth scroll) lands on the target, not near it.
  document.addEventListener(
    "click",
    function (e) {
      var link = e.target.closest ? e.target.closest("a[href*='#']") : null;
      if (!link || !link.hash || link.hash === "#") return;
      if (link.origin !== location.origin || link.pathname !== location.pathname || link.search !== location.search) return;
      document.documentElement.classList.add("cv-off");
    },
    true
  );

  // A hash change without a click (location.hash set by a script, a #id typed in the address bar): the browser has
  // already scrolled with the placeholder heights, so turn the skipping off and jump to the target again.
  window.addEventListener("hashchange", function () {
    var root = document.documentElement;
    if (root.classList.contains("cv-off")) return;
    root.classList.add("cv-off");
    var id = location.hash.slice(1), target = null;
    try { id = decodeURIComponent(id); } catch (err) {}
    if (id) target = document.getElementById(id);
    if (target) target.scrollIntoView();
  });
})();
